<a class="logo" style="z-index: 4;cursor:pointer;" href="">
    <img src="../../../assets/images/logo.jpg" alt="Rise Up Canada" title="Rise Up Canada">
</a>